import React from "react";

import noIconImg from '../../../assets/imgs/noImage.png'
import dummyDriverImg from '../../../assets/imgs/dummyDriver.png'

const CruzeAndPartner = ({ cruze, rider }) => {
  console.log("cruze",cruze)
  console.log("rider",rider)
  return (
    <div className="pt-5 pb-1">
      <h2 className="text-lg font-semibold mb-3">Selected Cruze</h2>

      <div className="p-4 rounded-md bg-gray-100 dark:bg-gray-800">
        <div className="flex items-center">
          {/* Vehicle Image */}
          <div className="w-20 flex justify-center items-center">
            {cruze?.thumbnailImage ? (
              <img
                src={cruze.thumbnailImage}
                alt="Vehicle"
                className="w-20 h-12 object-contain"
              />
            ) : (
              <img
                src={noIconImg} // Replace with your image path
                alt="No Image"
                className="w-12 h-12 rounded-full object-contain"
              />
            )}
          </div>

          {/* Vehicle Info */}
          <div className="pl-3 w-3/5">
            <p className="text-base font-semibold">{rider?.vehicle_name}</p>
            <p className="text-sm text-gray-500">
              {rider?.vehicleClass} - {rider?.vehicleColor}
            </p>
            <p className="text-sm text-gray-500">{rider?.vehicle_number}</p>
          </div>

          {/* Seating Capacity */}
          <div className="w-1/5 py-2 rounded-md bg-blue-500 text-center">
            <p className="text-white font-semibold">{rider?.vehicleSeatingCapacity}+1</p>
            <p className="text-white text-xs">Seater</p>
          </div>
        </div>

        {/* 360 View Component (You need to implement this in React.js) */}
        {/* <Cruze360View cruzeImages={rider.vehicle360View} /> */}

        {/* Rider Details */}
        <div className="flex items-center pt-3">
          {/* Driver Image */}
          <div className="w-16 flex justify-center items-center">
            {rider?.avatar_url ? (
              <img
                src={rider.avatar_url}
                alt="Driver"
                className="w-14 h-14 rounded-full object-contain"
              />
            ) : (
              <img
                src={dummyDriverImg}// Replace with your image path
                alt="Dummy Driver"
                className="w-12 h-12 rounded-full object-contain"
              />
            )}
          </div>

          {/* Driver Info */}
          <div className="pl-3 w-3/5">
            <p className="text-base font-semibold">
              {rider?.first_name} {rider?.last_name}
            </p>
            <p className="text-sm text-gray-500">Rated {rider?.rating} out of 5</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default React.memo(CruzeAndPartner);
